<template>
    <!--Refund and Transactions subpages-->
    <div class="admin-payments">
        <!--Refund subpage section-->
        <div v-if="user && isSectionVisible('refunds')">
            <!--Main contianer-->
            <div class="transactions-fees-container">
                <div class="transactions-heading">
                    <h3>{{ $t("adminMenu.refunds") }}</h3>
                    <div class="paragraph-heading-container">
                        <p class="paragraph-heading">{{ $t("payments.eligibleTransactions") }}</p>
                        <div class="show-info-modal-btn" v-on:click="showInfoModal()">
                            <i class="fa fa-info-circle info-button" aria-hidden="true"></i>
                            <div>{{ $t("payments.refund") }}</div>
                        </div>
                    </div>
                </div>
                <div v-if="!loadingRefunds" class="transactions-fees-wrap">
                    <div class="transactions-container">
                        <div class="transactions section-wrap">
                            <div v-if="paymentsLoaded && payments.length == 0" class="no-transactions">
                                {{ $t("payments.noTransactions") }}
                            </div>
                            <div v-if="paymentsLoaded && payments.length > 0" class="transactions-list">
                                <div v-for="(trans, index) in paymentsDisplayedItems" :key="`transaction${index}`"
                                    class="transaction-item highlighted-box">
                                    <div class="left-col">
                                        <div class="trans-name">{{ trans.name }}</div>
                                        <div class="trans-date">{{ trans.date }}</div>
                                        <div v-on:click="openAppointmentDetails(trans.appointment_id)"
                                            class="trans-appt-id transaction-button">
                                            {{ $t("payments.appointmentId") }} {{ trans.appointment_id }}
                                        </div>
                                    </div>
                                    <div class="right-col">
                                        <div class="trans-amount">{{ trans.amount }}</div>
                                        <div v-on:click="refundPayment(trans.order_id)"
                                            class="trans-refund-payment transaction-button">
                                            {{ $t("payments.refund") }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="transaction-load-more">
                                <div class="primary-btn extra-small mobile" v-if="paymentsHasMoreItems"
                                    @click="paymentsLoadMore">
                                    {{ $t("payments.loadMore") }}
                                </div>
                            </div>
                        </div>

                    </div>
                    <div class="fees-info-container">
                        <div class="section-wrap">
                            <p>{{ $t("payments.thereAreNoFees") }}</p>
                            <p>{{ $t("payments.yourCustomerSees") }}</p>
                            <p>{{ $t("payments.refundCannotBeCanceled") }}</p>
                        </div>
                    </div>
                </div>
                <MainLoader v-if="loadingRefunds" class="section-wrap" />
            </div>
            <!--Modal-->
            <div class="modal fade" id="refunds-details-modal" tabindex="-1" role="dialog" aria-labelledby="date-modal"
                aria-hidden="true" data-backdrop="false">
                <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <div>
                                <b>{{ $t("payments.refund") }}</b>
                            </div>
                            <div>
                                <button type="button" class="modal-close" data-bs-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                        </div>
                        <div class="modal-body book-sections">
                            <p>{{ $t("payments.thereAreNoFees") }}</p>
                            <p>{{ $t("payments.yourCustomerSees") }}</p>
                            <p>{{ $t("payments.refundCannotBeCanceled") }}</p>
                        </div>
                    </div>
                </div>
                <div class="modal-backdrop fade show"></div>
            </div>
        </div>
        <!--Transactions subpage section-->
        <div v-if="user && isSectionVisible('transactions')" class="transactions-main-container">
            <!--Transactions main container-->
            <div class="transcations-heading">
                <h3>{{ $t("adminMenu.transactions") }}</h3>
            </div>
        </div>
    </div>
</template>

<script>
import "bootstrap";
import api from "../../services/apiEndpoints.js";
import auth from "../../services/auth.js";
import store from "../../services/vuex.js";
import eventBus from "../../services/eventBus.js";
import messages from "../../services/messages.js";
import hash from "hash.js";
import $ from "jquery";

import MainLoader from "./general-components/MainLoader.vue";

export default {
    name: "PaymentsPage",
    props: ["sections"],
    data: function () {
        return {
            user: null,
            message: "",
            payments: [],
            paymentsLimit: 10,
            paymentsOffset: 0,
            paymentsLoaded: false,
            statements: [],
            statementsLoaded: false,
            currentTransaction: {},
            signatures: [],
            loading: false,
            allItemsLoaded: false,
            loadingRefunds: true,
        };
    },
    mounted: function () {
        this.user = auth.state.user;
        //check if adminDetails are either in store or loaded
        //if yes then do necessary logic
        if (this.$store.state.adminDetails.user) {
            this.onAdminDetailsLoad();
        }
        let self = this;
        eventBus.on("admin_details_loaded", function () {
            self.onAdminDetailsLoad();
        });

        eventBus.on("user_profile_loaded", function () {
            self.user = auth.state.user;
        });
    },
    beforeUnmount() {
        eventBus.off("admin_details_loaded");
        eventBus.off("user_profile_loaded");
    },
    computed: {
        paymentsDisplayedItems() {
            const keys = Object.keys(this.payments);
            return keys.slice(0, this.paymentsOffset + this.paymentsLimit).reduce((obj, key) => {
                obj[key] = this.payments[key];
                return obj;
            }, {});
        },
        paymentsHasMoreItems() {
            const keys = Object.keys(this.payments);
            return !this.allItemsLoaded && this.paymentsOffset + this.paymentsLimit < keys.length;
        },
        adminDetails: {
            get: function () {
                return this.$store.state.adminDetails;
            },
            set: function (value) {
                this.$store.commit("setAdminDetails", value);
            },
        },
    },
    methods: {
        paymentsLoadMore() {
            this.paymentsOffset += this.paymentsLimit;
            if (this.paymentsOffset >= Object.keys(this.payments).length) {
                this.allItemsLoaded = true;
            }
        },
        isSectionVisible(section) {
            if (!this.sections) {
                return true;
            }

            if (this.sections.indexOf(section) != -1) {
                return true;
            }

            return false;
        },
        async onAdminDetailsLoad() {
            this.loadingRefunds = true;

            try {
                await Promise.all([
                    this.getChargesList(),
                    this.getStatementsList()
                ]);
            } finally {
                this.loadingRefunds = false;
            }
        },
        getChargesList: function () {
            this.paymentsLoaded = false;

            return this.$http.get(api.actions.get_stripe_charges_list).then(
                function (response) {
                    this.paymentsLoaded = true;
                    if (response.data.error) {
                        return;
                    }
                    if (
                        typeof response != "undefined" &&
                        typeof response.data != "undefined" &&
                        typeof response.data.orders != "undefined" &&
                        response.data.orders.length > 0
                    ) {
                        this.payments = response.data.orders;
                    }

                }.bind(this),
                function () {
                    return false;
                }
            );
        },

        getStatementsList: function () {
            this.statementsLoaded = false;

            return this.$http.get(api.actions.get_statements).then(
                function (response) {
                    this.statementsLoaded = true;
                    if (response.data.error) {
                        return;
                    }
                    if (
                        typeof response != "undefined" &&
                        typeof response.data != "undefined" &&
                        typeof response.data.statements != "undefined" &&
                        response.data.statements.length > 0
                    ) {
                        this.statements = response.data.statements;
                        this.statements.forEach((item) => {
                            item.items.forEach((month) => {
                                month.displayLimit = 10;
                            });
                        });
                    }

                }.bind(this),
                function () {
                    return false;
                }
            );
        },

        refundPayment: function (order_id) {
            this.$swal({
                title: "Are you sure you want to refund this payment?",
                showCancelButton: true,
                confirmButtonText: "Yes",
                cancelButtonText: "No",
            }).then((result) => {
                if (result.value) {
                    let data = {
                        order_id: order_id,
                    };
                    this.$http.post(api.actions.refund_stripe_charge, data).then(
                        function (response) {
                            if (response.data.error) {
                                return;
                            }
                            messages.successMessage(messages.GLOBAL_MESSAGES.GENERAL_REFUND);
                            this.getChargesList();
                        }.bind(this),
                        function () {
                            return false;
                        }
                    );
                }
            });
        },

        showInfoModal() {
            $("#refunds-details-modal").modal("show");
        },
        openAppointmentDetails(id) {
            sessionStorage.setItem("openEventId", id);
            window.scrollTo(0, 0);
            this.$router.push("/app");
        },
        sendStatementsEmail(year, month) {
            let monthMap = {
                Jan: 1,
                Feb: 2,
                Mar: 3,
                Apr: 4,
                May: 5,
                Jun: 6,
                Jul: 7,
                Aug: 8,
                Sep: 9,
                Oct: 10,
                Nov: 11,
                Dec: 12,
            };
            let data = {
                year: year,
            };

            if (month) {
                data.month = monthMap[month];
            }

            this.$http.post(api.actions.send_statements_to_email, data).then(
                function (response) {
                    if (response && response.data.error) {
                        messages.errorMessage(messages.ERROR_MESSAGES.GENERAL_ERROR);
                        return;
                    }
                    messages.successMessage(messages.GLOBAL_MESSAGES.STATEMENTS_EMAIL_SENT + this.user.email);
                }.bind(this),
                function () {
                    return false;
                }
            );
        },

        getClientSignatures(payment_id) {
            this.loading = true;
            this.$http
                .get(api.actions.get_signatures_payment + payment_id)

                .then(
                    function (response) {
                        this.signatures = response.data.signatures;
                        this.loading = false;
                    }.bind(this),
                    function () {
                        return false;
                    }
                );
        },

        viewSignature(signature) {
            let token = hash.sha1().update(signature).digest("hex");
            return api.actions.view_signature + "?file_name=" + signature + "&token=" + token;
        },

        isDemoClient(user_id) {
            return import.meta.env.VITE_DEMO_CLIENT_ID == user_id;
        },
        openSignatureModal(transaction) {
            this.viewSignature(transaction.signature);
            this.currentTransaction = transaction;
        },
    },
    components: { MainLoader },
};
</script>
